/**
 * useWorkspaceSync — conecta diagramStore/historyStore ao workspaceStore.
 *
 * Deve ser chamado uma vez no AppShell. Faz duas coisas:
 * 1. Inicializa o workspace na montagem (migração ou restauração).
 * 2. Sincroniza o estado dos stores ativos de volta à aba ativa (debounced).
 */

import { useEffect, useRef } from 'react'
import { useDiagramStore } from '@/stores/diagramStore'
import { useHistoryStore } from '@/stores/historyStore'
import { useTabViewStore } from '@/stores/tabViewStore'
import { useTabsStore } from '@/stores/tabsStore'

const SYNC_DEBOUNCE_MS = 400

export function useWorkspaceSync() {
  const syncTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    // Inicializa o workspace ao montar (antes de configurar subscriptions)
    useTabsStore.getState().initWorkspace()

    function scheduleSync() {
      if (useTabsStore.getState().isSwitching) return
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current)
      syncTimerRef.current = setTimeout(() => {
        useTabsStore.getState().syncFromActiveStores()
      }, SYNC_DEBOUNCE_MS)
    }

    const unsubDiagram  = useDiagramStore.subscribe(scheduleSync)
    const unsubHistory  = useHistoryStore.subscribe(scheduleSync)
    const unsubTabView  = useTabViewStore.subscribe(scheduleSync)

    return () => {
      unsubDiagram()
      unsubHistory()
      unsubTabView()
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current)
    }
  }, [])
}
